
import { Button, Checkbox, Form, FormElement, InputText, Note } from '05-ui-kit';
import type { WatchStopHandle } from '@vue/composition-api';
import { ref, watch } from '@vue/composition-api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
interface Props {
  productId: number;
  status?: 'initial' | 'loading' | 'success' | 'error';
  response?: string;
}
const __sfc_main = {};
__sfc_main.props = {
  productId: {
    key: "productId",
    required: true,
    type: Number
  },
  status: {
    key: "status",
    required: false,
    type: String
  },
  response: {
    key: "response",
    required: false,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const isFeedbackBtnEnabled = ref(true);
  const foundCheaper = ref({
    number: '',
    source: '',
    code: props.productId
  });
  let resetWatcher: WatchStopHandle;
  const submited = ref(false);
  watch(() => props.status, value => {
    if (value === 'success') {
      submited.value = true;
      resetWatcher = watch(() => foundCheaper.value, () => {
        submited.value = false;
        resetWatcher();
      }, {
        deep: true
      });
    }
  });
  function onSubmit() {
    emit('send', foundCheaper.value);
  }
  return {
    isFeedbackBtnEnabled,
    foundCheaper,
    submited,
    onSubmit
  };
};
__sfc_main.components = Object.assign({
  ValidationObserver,
  Form,
  ValidationProvider,
  FormElement,
  InputText,
  Note,
  Button,
  Checkbox
}, __sfc_main.components);
export default __sfc_main;
